import { render } from "./Usuarios.vue?vue&type=template&id=bd880010"
import script from "./Usuarios.vue?vue&type=script&lang=ts"
export * from "./Usuarios.vue?vue&type=script&lang=ts"
script.render = render

export default script